import {
  MAX_PASSWORD_LENGTH,
  MIN_PASSWORD_LENGTH,
  PASSWORD_LETTER_REGEX,
  PASSWORD_NUMBER_REGEX,
  PASSWORD_SYMBOL_REGEX,
} from '@orn/global/auth/passwordConstraints.js';

interface IPasswordRule {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

interface IPasswordRuleResult extends IPasswordRule {
  met: boolean;
}

interface IPasswordValidationResult {
  rules: IPasswordRuleResult[];
}

const PASSWORD_RULES: IPasswordRule[] = [
  {
    id: 'length',
    label: '12+ characters (64 max)',
    test: (password) => password.length >= MIN_PASSWORD_LENGTH && password.length <= MAX_PASSWORD_LENGTH,
  },
  {
    id: 'number',
    label: 'Number (0-9)',
    test: (password) => PASSWORD_NUMBER_REGEX.test(password),
  },
  {
    id: 'letter',
    label: 'Letter (A-Z)',
    test: (password) => PASSWORD_LETTER_REGEX.test(password),
  },
  {
    id: 'symbol',
    label: 'Symbol (!@#$...)',
    test: (password) => PASSWORD_SYMBOL_REGEX.test(password),
  },
];

const validatePassword = (password: string): IPasswordValidationResult => {
  const rules = PASSWORD_RULES.map((rule) => ({
    ...rule,
    met: rule.test(password),
  }));

  return { rules };
};

export default validatePassword;

export { PASSWORD_RULES };
export type { IPasswordRule, IPasswordRuleResult, IPasswordValidationResult };
